import { gql } from '@apollo/client';

const LIST_COLLATERAL_REPORTS = gql`
  query ListCollateralReports($dealId: ID!) {
    listCollateralReports(input: { dealId: $dealId }) {
      reports {
        dealId
        zipFileName
        reportTitle
        createdAt
        zipS3VersionID
        uploadTimestamp
      }
    }
  }
`;

export default LIST_COLLATERAL_REPORTS;
